enum QBDCompanyFieldForOWCompanyNameEnum {
    COMPANY_NAME = "CompanyName",
    NAME = "Name",
    FULL_NAME = "FullName",
}

export default QBDCompanyFieldForOWCompanyNameEnum;
